
import { useNavigate } from "react-router-dom";
import { Box, Button, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useValidarRoles } from "../../hooks";
import { ModalFormulario } from "../components";
import { useModalStore } from "../../stores";
import { FormCrearUsuarioVenta } from "../compras/components";
import { startSavingCliente } from "../../services";





export const HeaderDeCheckout = ({ children, titulo }) => {

    
    const navigate = useNavigate();
    const { permitirXRol } = useValidarRoles();
    const { modalFormToggle } = useModalStore();



    const handleCrearUsuario = async(formCliente) => {
        const resp = await startSavingCliente( formCliente );
        return (resp) ? true : false;
    }



    return (

        <Box sx={{ display:'flex', flexDirection:'column', width:'100%', height:'100%', 
            minHeight:0, overflowY:'auto', overflowX:'hidden'
        }}>
            <Box sx={{ display:'flex', alignItems:'center', mb:3, width:'100%', flexShrink:0 }}>
                <IconButton sx={{ color: '#fff', backgroundColor: 'secondary.main' }} onClick={() => navigate(-1)}>
                    <ArrowBackIcon />
                </IconButton>

                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="h2" sx={{ textAlign: 'center' }}>
                        {titulo}
                    </Typography>
                </Box>

                {(permitirXRol('SUPERADMIN', 'ADMINISTRADOR', 'DISTRIBUIDOR'))
                ?   <Button variant="contained" color="secondary" onClick={() => modalFormToggle(true)} size="small">
                        Crear Cliente
                    </Button>
                :   <Box sx={{ width: 40 }} />
                }
            </Box>


            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                {children}
            </Box>


            <ModalFormulario titulo="Crear Usuario" valor={{}} onClose={() => modalFormToggle(false)}>
                <FormCrearUsuarioVenta funcion={handleCrearUsuario} />
            </ModalFormulario>
        </Box>
    )
}
